// noinspection JSUnusedGlobalSymbols
export enum Partner {
  AULAPP_TECH        = 16,
  DESCOMPLICA        = 2,
  EVOLUCIONAL        = 7,
  EVO_RED            = 22,
  GRUPO_MARISTA      = 23,
  KROTON             = 21,
  PLURALL            = 18,
  PLURALL_B2G        = 25,
  RED1000_CALIBRAGEM = 28,
  SESI_B2G           = 27,
  STOODI             = 20,
  WR                 = 14
}
